import React, { useContext } from 'react';
import { Tag } from 'antd';
import {
  getKey,
  removeItem,
} from '@approvals/services/approvals-page-drawer-service';
import { getRandomKey } from '@approvals/services/approvals-service';
import { ApprovalDrawerContext } from './approvals-edit-drawer';
import { Colors } from 'works/legacy/lib/style-helper';
import { ApprovalsEditDrawerApproverSelect } from './_approvals-edit-drawer-approver-select';
import { ApprovalChainApproverTemplateType } from '@approvals/graphql';

type Props = {
  approverTemplates: ApprovalChainApproverTemplateType[];
};

export const ApprovalsEditDrawerListApprovers = ({
  approverTemplates,
}: Props) => {
  const { forceUpdate, approvers, preApproved } = useContext(
    ApprovalDrawerContext
  );

  function addApprover(approverId: string) {
    const worksMembership = approvers.find((a) => a.value === approverId);
    approverTemplates.push({
      randomKey: getRandomKey(),
      worksMembership: {
        id: worksMembership?.value || '',
        name: worksMembership?.label || '',
      },
    });
    forceUpdate();
  }

  function removeApprover(index: number) {
    removeItem(approverTemplates, index);
    forceUpdate();
  }

  return (
    <>
      <ul className="approvals-drawer__lists">
        {approverTemplates.map(
          (approverTemplate, index) =>
            !approverTemplate.destroy && (
              <li
                key={getKey(approverTemplate)}
                className="approvals-drawer__approver-list-item"
              >
                <Tag
                  className="approvals-drawer__approver-tag text-heavy"
                  closable={!preApproved}
                  onClose={() => removeApprover(index)}
                >
                  {approverTemplate.worksMembership.name}
                </Tag>
                <span className="approvals-drawer__approver-or">OR</span>
              </li>
            )
        )}
        <li>
          <ApprovalsEditDrawerApproverSelect
            disabled={preApproved}
            forceSelect={approverTemplates.every((a) => a.destroy)}
            approvers={approvers.filter(
              (approver) =>
                !approverTemplates
                  .map(
                    (approverTemplate) => approverTemplate.worksMembership.id
                  )
                  .includes(approver.value)
            )}
            addApprover={addApprover}
          />
        </li>
      </ul>
      <style jsx>{`
        :global(.approvals-drawer__lists) {
          list-style: none;
          padding: 0;
          margin-bottom: 8px;
        }
        .approvals-drawer__approver-list-item:not(:last-child) {
          margin-bottom: 8px;
        }
        .approvals-drawer__approver-list-item:nth-last-child(2)
          .approvals-drawer__approver-or {
          display: none;
        }
        .approvals-drawer__approver-or {
          font-size: 13px;
          color: ${Colors.midnightLighter};
          margin-left: 10px;
        }
        :global(.approvals-drawer__approver-tag) {
          height: 32px;
          background-color: ${Colors.white};
          font-size: 14px;
          line-height: 32px;
          border: 1px solid ${Colors.steel};
        }
      `}</style>
    </>
  );
};
